import React, { Component } from 'react';
import {
  Grid, Row, Col, Panel, Button, ButtonGroup, DropdownButton, Table, Image, Input,
  Breadcrumb, MenuItem
} from 'react-bootstrap';
import { Link } from 'react-router';
import { Field } from 'redux-form';
import { SkyLightStateless } from 'react-skylight';
import { Translate, Localize } from 'react-redux-i18n';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT, BACKGROUND_COLOR } from '../Common/constants';
import GoogleMapContainer from '../GoogleMap/googleMapContainer';
import Spinner from '../../components/Widgets/spinner';
import WarehouseForm from '../../containers/Inventories/warehouseForm';
import checkPermission from '../Common/permissions';
import { companyCodeTitle } from '../../actions/root_url';
// import {buttonStyle, borderStyle} from '../Common/style'
// Dummy data

// const warehouses = [
//     {
//         id: '1',
//         Name: "RongCheng",
//         Address: "895 Dove Street, Irvine",
//         Contact: "Nat",
//         Email: "nat1988@gmail.com",
//         Phone: "192-583-4859",
//         Fax: "483-183-4582",
//         lng: "-117.8442962",
//         lat: "33.6404952"
//     },
//     {
//         id: '2',
//         Name: "Truckxi",
//         Address: "516 Veneto, Irvine",
//         Contact: "Mars",
//         Email: "asdf284@gmail.com",
//         Phone: "486-293-4931",
//         Fax: "867-103-5849",
//         lng: "-118.3533783",
//         lat: "34.1381168"
//     }
// ]

const renderSearchField = props => (
  <Input {...props.input} standalone type="text" placeholder="Warehouse Name" />
)

class Warehouse extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      currentWarehouse: {},
      tableHeight: window.innerHeight - UI_HEIGHT.noButton,
      warehouseOpen: false,
    };

    this.handleResize = this.handleResize.bind(this);
    this.searchWarehouses = this.searchWarehouses.bind(this);
    this.openWarehouse = this.openWarehouse.bind(this);
    this.closeWarehouse = this.closeWarehouse.bind(this);
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    if(this.props.selectedCompany.value) {
      this.props.fetchWarehouses();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.updated || (this.props.selectedCompany !== nextProps.selectedCompany)) {
      this.props.fetchWarehouses();
      this.closeWarehouse();
    }
  }

  handleResize(e) {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.noButton });
  }

  viewWarehouse(id) {
    this.props.resetCurrentWarehouse();
    this.props.selectWarehouse(id);
    this.context.router.push('/warehouses/detail');
  }

  editWarehouse(id) {
    this.props.resetCurrentWarehouse();
    this.props.selectWarehouse(id);
    this.openWarehouse();
    // this.context.router.push('/warehouses/form');
  }

  searchWarehouses() {
    const { fetchWarehouses, searchWarehouses, nameValue } = this.props
    if(!nameValue) fetchWarehouses();
    else searchWarehouses(nameValue);
  }

  openWarehouse() { this.setState({ warehouseOpen: true }); }
  closeWarehouse() { this.setState({ warehouseOpen: false }); }

  clickNew(e) {
    e.preventDefault();
    this.props.resetCurrentWarehouse();
    this.props.selectWarehouse({Company_id: this.props.selectedCompany.value, Company_id_id: this.props.selectedCompany.value});
    this.openWarehouse();
  }

  deleteZone(id) {
    this.props.resetCurrentWarehouse();
    this.props.deleteZone(id);
  }

  renderWarehousesDropdown() {
    let wList = [];
    if (this.props.isLoading && !this.props.error)return <Spinner/>
    else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{this.props.error.message}</div></ContentWrapper>
    else {
      const warehouses  = this.props.warehouses;
      if (warehouses) {
        for (let k = 0; k < warehouses.length; k++){
          let Name = warehouses[k].Name;
          let Warehouse_id = warehouses[k].Warehouse_id;
          wList.push(
            <MenuItem eventKey={k} style={{ width: '100%' }}>
              <Button
                onClick={() => {this.props.editWarehouseDefault(Warehouse_id, true)}}
                style={{ width: '100%' }}
                disabled={!checkPermission('change_warehouse')}
              >{Name + " ID: " + Warehouse_id}
              </Button>
            </MenuItem>
          )
        }
      }
    }
    return wList;
  }
  
  renderWarehouses() {
    if (this.props.isLoading && !this.props.error)return <Spinner/>
    else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{this.props.error.message}</div></ContentWrapper>
    else {
      const warehouses  = this.props.warehouses;
      if (warehouses) {
        return warehouses.map((warehouse) => {
          const { Name, Street, City, State, FirstName, LastName, Email, Telephone, Fax, Longitude, Latitude, Warehouse_id, IsDefault, warehouse_num} = warehouse;
          let Total_size = Math.floor(Math.random() * (100000 - 50000 + 1)) + 50000;
          const coordinate = { lng: Longitude, lat: Latitude };
          const Address = Street + ", " + City + ", " + State;
          const Contact = FirstName + " " + LastName;
          const WarehouseTitle = "Warehouse: " + Name;
          const currentWarehouse = { WarehouseTitle, Contact, Address, coordinate };
          const warehouseInitialValue = {
            ...warehouse,
            Remarks: warehouse.remarks,
          }
          // const warehousePanelHeader = ( <Row><Col xs={12}><h4>{Name}</h4></Col> </Row> );
          return (
            <div key={ Warehouse_id }>
              <br/>
              <Panel>
                <Row><Col xs={12}><h4>{Name}</h4></Col> </Row>
                <Row className="pull-right">
                    {/*<em className="fa fa-trash buttonStyle" onClick={() => { this.props.deleteWarehouse(Warehouse_id)}} />*/}<em className="fa fa-pencil buttonStyle" onClick={() => this.editWarehouse(warehouseInitialValue) } />
                </Row>
                <Row>
                  { (IsDefault) ?
                    <span style={{'padding-left': '8px'}} ><label className="label label-success" ><Translate value="default" /></label></span> :
                    ''
                  }
                </Row>
                {/* <Row><Col sm={ 12 }><Translate value="warehouse_id" /> {Warehouse_id}</Col> </Row> */}
                <Row><Col sm={ 12 }><Translate value="Code" />: {warehouse_num}</Col> </Row>
                <Row><Col sm={ 12 }><em className="fa fa-building-o marginRightStyle" />{Address || <Translate value="address" />}</Col></Row>
                <Row><Col sm={ 12 }><em className="fa fa-user marginRightStyle" />{Contact || <Translate value="contact_person" />}</Col></Row>
                <Row><Col sm={ 12 }><em className="fa fa-envelope marginRightStyle" />{Email || <Translate value="email" />}</Col></Row>
                <Row><Col sm={ 12 }><em className="fa fa-phone marginRightStyle" />{Telephone || <Translate value="phone" />}</Col></Row>
                <Row><Col sm={ 12 }><em className="fa fa-fax marginRightStyle" />{Fax || <Translate value="fax" />}</Col></Row>
                {/*<Row><Col sm={ 12 }><em className="fa fa-arrows marginRightStyle" />{Total_size || <Translate value="total_size" />} sq ft</Col></Row>*/}
                <Row><Col sm={ 12 }>
                  <a onClick={() => this.viewWarehouse(warehouse)} style={{cursor: "pointer"}}><Translate value="detail" /></a>
                  {/*<em className="fa fa-location-arrow pull-right buttonStyle" onClick={() => this.setState({ currentWarehouse: currentWarehouse }) }/>*/}
                </Col></Row>
              </Panel>
            </div>
          )
        })
      }
    }
  }

  formTitle() {
    if (this.props.currentWarehouse) return <Translate value="edit_warehouse" />;
    else return <Translate value="add_a_new_warehouse" />;
  }

  render() {
    const { isLoading, error, handleSubmit, selectedCompany} = this.props;
    let height = (this.state.tableHeight + 30).toString();
    let mapCollapseFix = {height: height};
    let searchBarHeight = ((this.state.tableHeight+ 30) / 5).toString();
    let searchBarCollapseFix = {height: searchBarHeight}
    return (
      //---------------
      // Begin HTML: Create New/Edit Warehouse
      //---------------
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="warehouse_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="warehouse" />
          </Breadcrumb.Item>
        </Breadcrumb>
        {/* <div className="content-heading"><Translate value="warehouse" /></div> */}
        <Grid fluid="true" id="warehouse-list">
          {/* <h1><Translate value="warehouse_map_view" /></h1> */}
          <Row >
            <Col sm={ 3 } style={{ overflowY: "scroll", maxHeight: height }}>
              <Col sm={ 12 }>
                <Panel>
                  <form onSubmit={handleSubmit(this.searchWarehouses) }>
                    <Row>
                      {/* <Col sm={ 7 }>
                          <Field name="WarehouseName" component={renderSearchField}/>
                      </Col>
                      <Col sm={ 2 }>
                          <Button type="submit"><em className="fa fa-search"/></Button>
                            </Col> */}
                      <Col sm={ 12 } style={{display: 'flex', justifyContent: 'center'}}>
                        <p style={{fontSize: '14px', fontWeight: 'bold'}}><Translate value="company" />: {selectedCompany ? selectedCompany.label : ""}</p>
                      </Col>
                      <Col sm={ 12 } style={{display: 'flex', justifyContent: 'center'}}>
                        <Button
                          bsStyle="primary"
                          onClick={(event) => { this.clickNew(event) } }
                          disabled={!checkPermission('add_warehouse')}
                        ><em className="fa fa-plus"/><Translate value="add_warehouse" /></Button>
                      </Col>
                      {/* <Col sm={ 5 }>
                          <Button
                              bsStyle="primary"
                              onClick={(event) => { this.clickNew(event) } }
                              disabled={!checkPermission('add_warehouse')}
                          ><em className="fa fa-plus"/><Translate value="add_company" /></Button>
                      </Col> */}
                    </Row>
                  </form>
                </Panel>
                <Panel>
                  <ButtonGroup className='warehouse_dropdown_group' style={{ 'width': '100%'}}>
                    <DropdownButton title={<Translate value="change_default_warehouse" />} disabled={!checkPermission('change_warehouse')} className="warehouse_dropdown" type="submit" bsStyle="success" style={{ 'width': '100%'}} >
                      { this.renderWarehousesDropdown() }
                    </DropdownButton>
                  </ButtonGroup>
                </Panel>
              </Col>
              <Col sm={ 12 } >
                { this.renderWarehouses() }
                <SkyLightStateless isVisible={this.state.warehouseOpen} onCloseClicked={() => { this.closeWarehouse() } } title={this.formTitle() } dialogStyles={{ height: '550px' }}>
                  <WarehouseForm closeG={this.closeWarehouse} />
                </SkyLightStateless>
              </Col>
            </Col>
            <Col sm={ 9 }>
              <Panel style={ mapCollapseFix }>
                <GoogleMapContainer currentWarehouse={this.state.currentWarehouse} responsive={true}/>
              </Panel>
            </Col>
          </Row>
        </Grid>
      </ContentWrapper>
    );
  }
}



export default Warehouse;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/warehouses.jsx